import { AbstractControl, ValidatorFn } from '@angular/forms';

export class ViaValidators {
  /**
   * Checks whether a string has only white space characters in it
   * Returns error if it does
   */
  static noOnlyWhiteSpaceValidator(control: AbstractControl) {
    return !control.value?.trim().length ? { noOnlyWhiteSpace: true } : null;
  }

  /**
   * Checks whether a string has a white space character in it or not
   * Returns error if it does
   */
  static noWhiteSpaceValidator(control: AbstractControl) {
    return /\s/.test(control.value) ? { noWhiteSpace: true } : null;
  }

  /**
   * Validate if a date is less than max date provided or not
   * Returns error if it is not
   */
  static maxDateValidator(maxDate: Date = new Date()): ValidatorFn {
    return (control: AbstractControl) => {
      const selectedDate = new Date(control.value);

      if (selectedDate > maxDate) {
        return { maxDate: true };
      }

      return null;
    };
  }

  /**
   * Validate if a date is greater than min date provided or not
   * Returns error if it is not
   */
  static minDateValidator(minDate: Date): ValidatorFn {
    return (control: AbstractControl) => {
      if (!control.value) return null;
      const selectedDate = new Date(control.value);
      return selectedDate < minDate ? { minDate: true } : null;
    };
  }

  /**
   * Validate email as per VIA standards
   */
  static emailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const { value } = control;
      const emailPattern = /^[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,}$/;
      if (value && !emailPattern.test(value)) {
        return { invalidEmail: true };
      }
      return null;
    };
  }
}
